'use client';

import { usePathname } from 'next/navigation';
import { useTranslations, useLocale } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { ThemeToggle } from '@/components/layout/ThemeToggle';
import { LanguageSelector } from '@/components/LanguageSelector';

export function SiteNav() {
  const pathname = usePathname();
  const locale = useLocale();
  const t = useTranslations('Nav');

  const LINKS = [
    { href: '/features', label: t('features') },
    { href: '/pricing', label: t('pricing') },
  ];

  return (
    <header className="sticky top-0 z-50 bg-stone-50/90 dark:bg-zinc-950/90 backdrop-blur-md border-b border-stone-200/80 dark:border-zinc-800/80 transition-colors">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-4">
        <Link href="/" className="flex items-center gap-2 shrink-0 hover:opacity-80 transition-opacity">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/logo-black.webp" alt="" width={28} height={28} className="shrink-0 dark:hidden" style={{ width: 28, height: 28, objectFit: 'contain' }} />
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/logo-white.webp" alt="" width={28} height={28} className="shrink-0 hidden dark:block" style={{ width: 28, height: 28, objectFit: 'contain' }} />
          <span className="font-semibold text-sm tracking-tight text-stone-950 dark:text-zinc-50">Lithosbase</span>
        </Link>

        <nav className="hidden md:flex items-center gap-0.5">
          {LINKS.map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className={`px-3.5 py-1.5 text-sm rounded-md transition-colors ${
                pathname?.endsWith(href)
                  ? 'text-stone-950 dark:text-zinc-50 font-medium bg-stone-100 dark:bg-zinc-800'
                  : 'text-stone-500 dark:text-zinc-400 hover:text-stone-900 dark:hover:text-zinc-100 hover:bg-stone-100 dark:hover:bg-zinc-900'
              }`}
            >
              {label}
            </Link>
          ))}
          {/* Catalog route is NOT locale-prefixed — pass ?lang= so UI matches current locale */}
          <a
            href={`/c/workshop?lang=${locale}`}
            className="px-3.5 py-1.5 text-sm rounded-md transition-colors text-stone-500 dark:text-zinc-400 hover:text-stone-900 dark:hover:text-zinc-100 hover:bg-stone-100 dark:hover:bg-zinc-900"
          >
            {t('catalogDemo')}
          </a>
        </nav>

        <div className="flex items-center gap-1.5">
          <LanguageSelector />
          <ThemeToggle collapsed />
          <Link
            href="/login"
            className="inline-flex px-3.5 py-1.5 text-sm text-stone-500 dark:text-zinc-400 hover:text-stone-900 dark:hover:text-zinc-100 hover:bg-stone-100 dark:hover:bg-zinc-900 rounded-md transition-colors"
          >
            {t('login')}
          </Link>
        </div>
      </div>
    </header>
  );
}
